import { Box, Stack, Typography } from 'ui';
import { CheckCircleOutline } from 'ui/icons';

export const StepThree = ({ children }: { children: JSX.Element }) => {
  return (
    <Stack alignItems="center" gap={2}>
      <Box display="flex" alignItems="center" gap={1}>
        <Typography fontWeight="bold">AI Analysis Instant Feedback</Typography>
        <CheckCircleOutline />
      </Box>

      {children}

      <Typography textAlign="center">
        Photos that have been successfully analysed by the AI show a green tick (coming soon for AI Gravi).
      </Typography>
    </Stack>
  );
};
